import CreateReducer from '@nocode-works/template/store/utils/createReducer'
import CreateActions from '@nocode-works/template/store/utils/createActions'
import networkWrapper from '@nocode-works/template/store/utils/networkWrapper'
import {
  handlers,
} from '@nocode-works/template/store/utils/api'

const prefix = 'template'
const wrapper = networkWrapper.factory(prefix)

const initialState = {
  templates: [],
  allTemplates: [],
  versions: [],
}

const reducers = {
  setTemplates: (state, action) => {
    state.templates = action.payload
  },
  setAllTemplates: (state, action) => {
    state.allTemplates = action.payload
  },
  setTemplate: (state, action) => {
    const newTemplate = action.payload
    const exists = state.templates.find(t => t.id == newTemplate.id)
    if(exists) {
      state.templates = state.templates.map(t => {
        return t.id ==  newTemplate.id ?
          newTemplate :
          t
      })
    }
    else {
      state.templates = state.templates.concat([newTemplate])
    }
  },
  setVersions: (state, action) => {
    state.versions = action.payload
  }
}

const sideEffects = {
  
  list: () => wrapper('list', async (dispatch, getState) => {
    const data = await handlers.get(`/templates`)
    dispatch(actions.setTemplates(data))
  }),

  listAll: () => wrapper('listAll', async (dispatch, getState) => {
    const data = await handlers.get(`/templates/all`)
    dispatch(actions.setAllTemplates(data))
  }),

  get: (id) => wrapper('get', async (dispatch, getState) => {
    const template = await handlers.get(`/templates/${id}`)
    const versions = await handlers.get(`/templates/${id}/versions`)
    dispatch(actions.setTemplate(template))
    dispatch(actions.setVersions(versions))
  }),
}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export { actions, reducer }
export default actions
